import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { Toaster } from "@roqua/components/ui/sonner";

import { getMatomoSiteId, getMatomoUrl } from "@/analytics";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { MatomoTracker } from "@/components/MatomoTracker";
import { ThemeProvider } from "@/components/ThemeProvider";

export const Route = createRootRoute({
  component: () => (
    <>
      <MatomoTracker matomoUrl={getMatomoUrl()} siteId={getMatomoSiteId()} />

      <ErrorBoundary>
        <DndProvider backend={HTML5Backend}>
          <ThemeProvider defaultTheme="light" storageKey="roqua-ui-theme">
            <Outlet />
          </ThemeProvider>
        </DndProvider>
      </ErrorBoundary>
      <Toaster offset={{ top: "88px" }} />

      {import.meta.env.DEV && <TanStackRouterDevtools />}
    </>
  ),
  head: () => ({
    meta: [
      {
        charSet: "utf-8",
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1",
      },
      {
        name: "description",
        content: "RoQua - Digital mental health platform",
      },
    ],
    title: "RoQua",
  }),
});
